import React from 'react';

function ConsentModal({ isOpen, onClose, onAgree }) {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(2, 6, 23, 0.72)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-end',
        zIndex: 2000,
        padding: '1rem',
        paddingBottom: 'max(1rem, calc(env(safe-area-inset-bottom, 0px) + 12px))',
      }}
    >
      <div
        style={{
          background: '#fff',
          padding: '1.25rem',
          borderRadius: '22px 22px 18px 18px',
          maxWidth: '520px',
          width: '100%',
          boxShadow: '0 18px 40px rgba(0,0,0,0.3)',
          fontFamily: "'Segoe UI', sans-serif",
          lineHeight: 1.65,
          color: '#334155',
        }}
      >
        <div
          style={{
            width: '44px',
            height: '5px',
            borderRadius: '999px',
            background: '#e2e8f0',
            margin: '0 auto 1rem',
          }}
        />

        <h2 style={{ fontSize: '1.18rem', fontWeight: 700, margin: '0 0 0.75rem', textAlign: 'left', color: '#0f172a' }}>
          연구 목적 데이터 저장 동의
          <span style={{ fontSize: '0.84rem', fontWeight: 500, color: '#64748b' }}> (선택)</span>
        </h2>

        <p style={{ fontSize: '0.93rem', margin: 0, textAlign: 'left', color: '#475569' }}>
          얼굴 사진은 분석 후 기본적으로 저장되지 않습니다.
          <br />
          다만 동의하시면 서비스 개선과 연구 목적을 위해 가명 처리된 데이터를 보관할 수 있습니다.
          <br />
          동의하지 않아도 분석은 그대로 진행됩니다.
        </p>

        <div
          style={{
            display: 'grid',
            gap: '0.75rem',
            marginTop: '1.2rem',
          }}
        >
          <button
            onClick={onAgree}
            style={{
              minHeight: '52px',
              padding: '0.85rem 1rem',
              background: 'linear-gradient(90deg, #ec4899, #8b5cf6)',
              color: '#fff',
              border: 'none',
              borderRadius: '14px',
              cursor: 'pointer',
              fontSize: '0.98rem',
              fontWeight: 700,
            }}
          >
            동의하고 진행
          </button>

          <button
            onClick={onClose}
            style={{
              minHeight: '52px',
              padding: '0.85rem 1rem',
              border: '1px solid #cbd5e1',
              borderRadius: '14px',
              background: '#fff',
              cursor: 'pointer',
              fontSize: '0.95rem',
              color: '#334155',
              fontWeight: 700,
            }}
          >
            동의 없이 진행
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConsentModal;
